import { Box, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import {
  FLOWCODE_PRIVACY_POLICY,
  FLOWCODE_TERMS_OF_USE_LINK,
  FLOWCODE_TRIALS_TERMS_OF_SERVICE
} from '../../constants/PrivacyTermsOfService'
import Link from 'next/link'
import Trans from 'next-translate/Trans'

const defaultDisclaimer =
  '<p>By proceeding, you agree to the <termsLink>Terms of Use</termsLink> of the trial and you acknowledge that you have read our <privacyLink>Privacy Policy</privacyLink>.</p>'
const defaultNonTrialDisclaimer =
  '<p>By proceeding, you agree to the <termsLink>Terms of Use</termsLink> and you acknowledge that you have read our <privacyLink>Privacy Policy</privacyLink>.</p>'

export const AuthDisclaimer: FC<{
  isUS: boolean
  ssoMode: boolean
  isNonTrialPlan?: boolean
  versionEmailFieldsAboveTheFold?: boolean
}> = ({ isUS, ssoMode, isNonTrialPlan, versionEmailFieldsAboveTheFold }) => {
  return (
    <Box sx={{ mt: versionEmailFieldsAboveTheFold ? 2 : 6 }} data-testid="disclaimer-line-1">
      {isUS && !ssoMode && (
        <Box sx={{ mt: 2 }} data-testid="disclaimer-line-2">
          <Trans
            i18nKey={
              isNonTrialPlan
                ? 'authentication:NonTrialDisclaimer2'
                : 'authentication:DisclaimerLine2'
            }
            components={{
              p: <Typography variant="labelSmall" component={'p'} color="onSurface.secondary" />,
              termsLink: (
                <Link
                  href={
                    isNonTrialPlan ? FLOWCODE_TERMS_OF_USE_LINK : FLOWCODE_TRIALS_TERMS_OF_SERVICE
                  }
                  target="_blank"
                  style={{ textDecoration: 'underline' }}
                  data-testid="flowcode-terms-of-use"
                />
              ),
              privacyLink: (
                <Link
                  href={FLOWCODE_PRIVACY_POLICY}
                  target="_blank"
                  style={{ textDecoration: 'underline' }}
                  data-testid="flowcode-privacy-policy"
                />
              )
            }}
            defaultTrans={isNonTrialPlan ? defaultNonTrialDisclaimer : defaultDisclaimer}
          />
        </Box>
      )}
    </Box>
  )
}
